const DEFAULT_ROW_HEIGHT = 32;
const OVERSCAN_ROW_COUNT = 20;
const OVERSCAN_COLUMN_COUNT = 3;
const INDEX_COLUMN_INDEX = -1;
const INDEX_ROW_INDEX = 0;
const TABLE_HIDDEN_ROWS_AT_LIMIT = 3;
const TABLE_ROW_LIMIT = 5e5;
const TABLE_HEIGHT_LIMIT_FACTOR = TABLE_ROW_LIMIT + TABLE_HIDDEN_ROWS_AT_LIMIT + 1;
const HIDE_TOOLTIPS_CLASS = "hide-tooltips";
const CELL_TOOLTIP_CLASS = "tooltip-wrapper";
export {
  CELL_TOOLTIP_CLASS,
  DEFAULT_ROW_HEIGHT,
  HIDE_TOOLTIPS_CLASS,
  INDEX_COLUMN_INDEX,
  INDEX_ROW_INDEX,
  OVERSCAN_COLUMN_COUNT,
  OVERSCAN_ROW_COUNT,
  TABLE_HEIGHT_LIMIT_FACTOR,
  TABLE_HIDDEN_ROWS_AT_LIMIT,
  TABLE_ROW_LIMIT
};
